export const ASSET_STATUS_PROCESSING = 1;
export const PROCESSING_POLL_MS = 15_000;

export const isAssetProcessing = (status?: number | null) =>
    status === ASSET_STATUS_PROCESSING;

export const processingRefetchInterval = (
    isProcessing: boolean,
    idleInterval: number | false = false
) => (isProcessing ? PROCESSING_POLL_MS : idleInterval);

type AssetWithStatus = { id?: string; asset_status?: number } | null | undefined;

export const collectProcessingAssetIds = (
    ...lists: Array<AssetWithStatus[] | null | undefined>
): string[] => {
    const ids = new Set<string>();

    lists.forEach((list) => {
        list?.forEach((asset) => {
            if (asset?.id && isAssetProcessing(asset.asset_status)) {
                ids.add(asset.id);
            }
        });
    });

    return [...ids];
};
